import declare from "dojo/_base/declare";
import Delete from "csi/table/Delete";
import locale from "csi/locale";
import MessageDialog from "csi/widget/MessageDialog";
import xml from "csi/xml";
import { CallMethod } from "csi/xml/CallMethod";

const RemoveReferenceSizeCharts = declare(Delete, {
	/**
   * @override
   */
	toWriter(): CallMethod {
		const call = this.inherited<CallMethod>(arguments);

		const { m_urlParent: styleURL, m_urlNode: shapeSizeChartURL } = this;

		call.addParameter("SizeChartURL", xml.ATTR_CNL, shapeSizeChartURL);
		call.addParameter("URL", xml.ATTR_STRING, styleURL);
		return call;
	},

	/**
   * @override
   */
	confirmAction(params: any): void {
		const styleName = locale.getNodeName(this.getParent());
		params.materialIcon = MessageDialog.ICON_WARNING;
		params.title = locale.resource("RemoveReferenceSizeChart_Title");
		params.message = locale.resource("RemoveReferenceSizeChart_Confirm", [styleName]);
		this.m_action.confirmAction = MessageDialog.BUTTON_REMOVE;

		this.inherited(arguments);
	},
});

export = RemoveReferenceSizeCharts;
